import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../lib/constants";

export const Services = ({ compact = false }) => {
  const data = compact ? SERVICES : SERVICES;
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-700">
            Our Services
          </div>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-light text-slate-900">
            Cleaning solutions, <span className="font-medium">tailored to every space.</span>
          </h2>
          <p className="mt-4 text-slate-600 leading-relaxed">
            From homes and offices to short-term rentals and post-renovation
            handovers — we bring the same meticulous standard to every visit.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {data.map((s, idx) => (
            <Link
              key={s.slug}
              to="/services"
              data-testid={`service-card-${s.slug}`}
              className="group relative bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-3d hover:shadow-3d-hover gradient-border tilt-card transition-all duration-500"
              style={{ animationDelay: `${idx * 60}ms` }}
            >
              {/* Card glow */}
              <div className="absolute -inset-px rounded-2xl bg-gradient-to-br from-blue-500/0 via-sky-400/0 to-indigo-500/0 group-hover:from-blue-500/10 group-hover:via-sky-400/10 group-hover:to-indigo-500/10 transition-all duration-700 pointer-events-none" />
              <div className="aspect-[4/3] overflow-hidden bg-slate-100 relative">
                <img
                  src={s.image}
                  alt={s.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
              <div className="p-6 relative">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-display text-xl font-medium text-slate-900 group-hover:text-blue-700 transition-colors">
                    {s.title}
                  </h3>
                  <span className="shrink-0 w-9 h-9 rounded-full bg-slate-50 group-hover:bg-gradient-to-br group-hover:from-blue-600 group-hover:to-sky-500 group-hover:text-white text-slate-700 flex items-center justify-center transition-all duration-500 group-hover:shadow-glow-soft">
                    <ArrowUpRight className="w-4 h-4 transition-transform duration-500 group-hover:rotate-12" />
                  </span>
                </div>
                <p className="mt-2.5 text-sm text-slate-600 leading-relaxed">
                  {s.short}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
